<template>
  <div class="xg">
    <div class="xg__team-switch">
      <div class="xg__team-switch__team">
        <span :title="homeTeam.colloquial_name">{{ homeTeam.colloquial_name }}</span>
        <div class="xg__team-switch__team__logo">
          <img :src="homeTeam.logo" alt="" />
        </div>
      </div>
      <BSwitch
        size="is-small"
        type="is-success"
        passive-type="is-success"
        v-model="team"
        true-value="Visiting"
        false-value="Local"
      />
      <div class="xg__team-switch__team">
        <div class="xg__team-switch__team__logo">
          <img :src="visitingTeam.logo" alt="" />
        </div>
        <span :title="visitingTeam.colloquial_name"> {{ visitingTeam.colloquial_name }}</span>
      </div>
    </div>
    <div class="xg__chalkboard">
      <SoccerChalkboard :plays="plays" :categories="categories" :team="team" />
    </div>
    <div class="xg__table">
      <div class="xg__table__first-row xg__table__name-row"></div>
      <div class="xg__table__team-logo xg__table__first-row xg__table__value-row ">
        <img :src="stringSelectedTeamLogo" alt="" />
      </div>
      <template v-for="(item, index) of gxInfoItems">
        <div class="xg__table__name-row" :key="200 + index">
          {{ item.title }}
        </div>
        <div class="xg__table__value-row" :key="400 + index">
          {{ item.value }}
        </div>
      </template>
    </div>
    <div class="xg__what-is">
      <span>xG:</span> es la medida para estimar la probabilidad de que un tiro o una jugada termine en gol, basándose
      en factores como la ubicación y la dificultad de la acción.
      <!-- <div
        @click="openXgVideo"
        class="button xg__what-is-btn is-rounded is-primary"
        :size="windowWidth < 769 ? 'is-small' : ''"
      >
        <span class="xg__what-is-text">¿Qué es <b>xG?</b></span>
        <span class="xg__what-is-icon">
          <i class="mdi mdi-play-circle-outline" />
        </span>
      </div> -->
    </div>
  </div>
</template>

<script>
import SoccerChalkboard from '@/components/Elements/SoccerChalkboardXg.vue';
import { mapGetters, mapMutations, mapActions, mapState } from 'vuex';
import { normalPlayer } from '@/data/xg/chalkboardCategories';
// import { clickVerExpectativaDeGolDeEquipo, clickVerVideoQueEsXg } from '@/utils/analytics';
import { BSwitch } from 'buefy/dist/esm/switch';

export default {
  name: 'Xg',
  components: {
    SoccerChalkboard,
    BSwitch,
  },
  data() {
    return {
      categories: normalPlayer,
    };
  },
  computed: {
    ...mapState('nextGeneral', ['usePastSeasonId', 'pastSeasonId', 'gameId']),
    ...mapState('general', ['booleanIsStatisticModalOpen']),
    ...mapGetters('xgGeneral', ['plays', 'goalsQty', 'shotsOnGoalQty', 'xG']),
    ...mapGetters('nextGeneral', ['getSeasonId', 'homeTeam', 'visitingTeam', 'showPostMatchData']),
    ...mapGetters('loginGeneral', ['getPremiumAccount', 'getIsGolstats']),
    ...mapGetters('general', ['getPreviewSectionAnalytics']),
    team: {
      get() {
        return this.$store.state.xgGeneral.teamSelected;
      },
      set(newVal) {
        // clickVerExpectativaDeGolDeEquipo({
        //   team_id: this.getTeamId(newVal),
        //   game_id: this.gameId,
        //   is_premium: this.getPremiumAccount,
        //   golstats: this.getIsGolstats,
        //   preview_section: this.getPreviewSectionAnalytics,
        // });
        this.setTeamSelected(newVal);
      },
    },

    stringSelectedTeamLogo() {
      return this.team === 'Local' ? this.homeTeam.logo : this.visitingTeam.logo;
    },

    windowWidth() {
      return this.$store.state.windowWidth;
    },

    gxInfoItems() {
      return [
        { title: 'Goles', value: this.goalsQty },
        { title: 'Tiros a Gol', value: this.shotsOnGoalQty },
        { title: 'Goles esperados (xG)', value: this.xG },
      ];
    },
  },
  watch: {
    visitingTeam: {
      deep: true,
      handler(newValue) {
        if (newValue) {
          this.fillXgPlays();
        }
      },
    },
    booleanIsStatisticModalOpen: {
      immediate: true,
      handler(newValue) {
        if (!newValue) {
          this.team = 'Local';
        }
      },
    },
  },
  methods: {
    ...mapMutations('general', ['setVideoSrc', 'setVideoModalVisibility']),
    ...mapMutations('xgGeneral', ['setTeamSelected']),
    ...mapActions('xgGeneral', ['getXgPlays']),
    openXgVideo() {
      // clickVerVideoQueEsXg(this.getPremiumAccount, this.getPreviewSectionAnalytics, this.getIsGolstats);
      this.setVideoSrc('');
      this.setVideoModalVisibility(true);
    },
    getTeamId(playingAs) {
      let teamId;
      switch (playingAs) {
        case 'Visiting':
          teamId = this.visitingTeam.team_id;
          break;
        case 'Local':
          teamId = this.homeTeam.team_id;
          break;
      }
      return teamId;
    },
    fillXgPlays() {
      if (this.showPostMatchData) {
        this.getXgPlays({
          seasonId: this.gameId,
          localTeamId: this.homeTeam.team_id,
          visitingTeamId: this.visitingTeam.team_id,
          postMatch: this.showPostMatchData,
        });
      } else {
        this.getXgPlays({
          seasonId: this.usePastSeasonId ? this.pastSeasonId : this.getSeasonId,
          localTeamId: this.homeTeam.team_id,
          visitingTeamId: this.visitingTeam.team_id,
        });
      }
    },
  },
  beforeMount() {
    this.fillXgPlays();
  },
};
</script>

<style lang="scss" scoped>
$break-point-max: 800px;
$break-point-min: 801px;

.xg {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  &__team-switch {
    width: 100%;
    max-width: 31.25em;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 3.5rem;
    font-family: Avenir-Demi-Medium, sans-serif;
    font-size: 1em;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: right;
    color: #1e2021;
    border-radius: 36px;
    border: solid 1px #d9d9d9;

    &__team {
      display: flex;
      justify-content: center;
      align-items: center;

      &__logo {
        height: 32px;
        width: 32px;
        margin: 0 10px;

        & > img {
          height: 32px;
          width: 32px;
        }
      }
    }

    & .switch {
      margin: 0 10px 0 14px;
    }
    & > div {
      width: 40%;
      display: flex;
    }
    & > div:first-child {
      justify-content: flex-end;
    }
    & > div:last-child {
      justify-content: flex-start;
    }
    & > div span {
      text-align: center;
      line-height: initial;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      cursor: default;
    }
  }
  &__what-is {
    margin-top: 2em;
    width: 100%;

    & > span {
      font-family: Avenir-Bold, sans-serif;
      font-weight: bold;
    }
  }
  &__chalkboard {
    margin-top: 0;
    width: 700px;
  }

  &__table {
    width: 100%;
    max-width: 400px;
    display: grid;
    grid-template-columns: repeat(2, 2fr);
    font-family: Avenir-Demi, sans-serif;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #1e2021;

    & > div {
      border: solid 0.5px #eaeaeb;
      width: 100%;
      padding: 0.7em 0 0.5em;
    }

    &__team-logo {
      & > img {
        width: 40px;
        height: 40px;
      }
    }

    &__first-row {
      border-top: none !important;
    }

    &__name-row {
      border-left: none !important;
      text-align: left;
      padding-left: 2em !important;
    }

    &__value-row {
      border-right: none !important;
    }
  }

  @media screen and (max-width: 724px) {
    &__chalkboard {
      width: 500px;
    }
  }

  @media screen and (max-width: 520px) {
    &__team-switch {
      width: 100%;
      max-width: 100%;
      height: 2.5rem;
      font-size: 0.85em;
      border-radius: 12px;
    }
    &__chalkboard {
      margin-top: 0.5em;
      width: 400px;
    }
    &__table {
      margin-top: -20px;
      max-width: 80%;
    }
  }

  @media screen and (max-width: 419px) {
    &__team-switch {
      height: 1.8rem;
      font-size: 0.8em;

      &__team {
        &__logo {
          height: 22px;
          width: 22px;
          margin: 0 5px;

          & > img {
            height: 22px;
            width: 22px;
          }
        }
      }

      & .switch {
        margin: 0 6px 0 10px;
      }
    }
    &__chalkboard {
      margin-top: 1.5em;
      width: 100%;
    }

    &__table {
      max-width: 270px;
      grid-template-columns: 1fr 60px;
      font-size: 13px;
      margin-top: -40px;
    }
  }
}

/*@media screen and (min-width: $break-point-min) {
  .xg {
    grid-template-areas:
      'switch switch switch switch switch'
      'whatis whatis chalkboard chalkboard chalkboard'
      'info info chalkboard chalkboard chalkboard'
      '. . chalkboard chalkboard chalkboard';

    &__team-switch {
      width: 100%;
    }

    &__info {
      flex-flow: column nowrap;
      border: solid 1px #d8d8d8;
      border-radius: 7px;
      margin: 0 0 0 2vw;
      width: 100%;
      max-width: 260px;
      height: min-intrinsic;
      &-item {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        border-bottom: solid 1px #d8d8d8;
        padding: 0.8em 0;
        &-left,
        &-right {
          width: 100%;
        }
        &-left {
          text-align: left;
          padding-left: 1em;
        }
      }
      &-item:last-child {
        border-bottom: none;
      }
    }

    &__what-is {
      margin: 3vh 0 3vh 2vw;
      max-width: 260px;
      &-btn {
        height: 1rem;
      }
      &-text {
        font-size: 0.8em;
      }
    }

    &__chalkboard {
      width: 120%;
      margin-left: -35px;
    }
  }
}

@media screen and (max-width: $break-point-max) {
  .xg {
    grid-template-areas:
      'switch switch switch switch'
      'info info info info'
      'whatis whatis whatis whatis'
      'chalkboard chalkboard chalkboard chalkboard';

    &__team-switch {
      width: 100%;
      & > div span {
        min-width: 35%;
      }
    }

    &__info {
      flex-flow: row nowrap;
      width: 90%;
      height: 7vh;
      max-height: 42px;
      border-bottom: dotted 1px black;
      &-item {
        width: 60%;
        height: 1em;
        &-left,
        &-right {
          display: inline;
          white-space: nowrap;
        }
      }

      &-item:nth-child(2) {
        width: 100%;
        border: dotted 1px black;
        border-top: none;
        border-bottom: none;
      }
    }

    &__what-is {
      margin: 1.7vw 0 0;
      &-btn {
        height: 1.2rem;
      }
      &-text {
        font-size: 0.8rem;
      }
    }

    &__chalkboard {
      width: 90%;
      margin-top: 20px;
    }
  }
}
@media screen and (max-width: 390px) {
  .xg {
    &__what-is {
      margin: 3vw 0 0;
    }
    &__chalkboard {
      margin-top: 20px;
      width: 100%;
    }
    &__info {
      &-item {
        &-left,
        &-right {
          font-size: 0.85rem;
        }
      }

      &-item:nth-child(2) {
        width: 100%;
        border: dotted 1px black;
        border-top: none;
        border-bottom: none;
      }
    }
  }
}*/
</style>
